import { render, staticRenderFns } from "./contentCourseDelete.vue?vue&type=template&id=4281279e&"
import script from "./contentCourseDelete.vue?vue&type=script&lang=js&"
export * from "./contentCourseDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports